/**
 * HTTP-клиент для работы с API.
 * Автоматически подставляет JWT-токен и обрабатывает 401.
 */

const API_BASE = '/api';

class ApiClient {
    private getToken(): string | null {
        return localStorage.getItem('token');
    }

    private async request<T>(
        method: string,
        path: string,
        body?: unknown,
    ): Promise<T> {
        const headers: Record<string, string> = {
            'Content-Type': 'application/json',
        };

        const token = this.getToken();
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        const response = await fetch(`${API_BASE}${path}`, {
            method,
            headers,
            body: body ? JSON.stringify(body) : undefined,
        });

        /* Если токен протух — выкидываем на логин */
        if (response.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
            throw new Error('Unauthorized');
        }

        if (!response.ok) {
            const err = await response.json().catch(() => ({ detail: 'Ошибка сервера' }));
            throw new Error(err.detail || `Ошибка ${response.status}`);
        }

        return response.json();
    }

    get<T>(path: string)              { return this.request<T>('GET', path); }
    post<T>(path: string, body: any)  { return this.request<T>('POST', path, body); }
    put<T>(path: string, body: any)   { return this.request<T>('PUT', path, body); }
    del<T>(path: string)              { return this.request<T>('DELETE', path); }
}

export const api = new ApiClient();
